// src/Pages/Load/LoadContainer/modals/ModalContent.jsx

"use client";

import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

import { Button } from "../../../../Components/ui/button";
import {
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogHeader,
  DialogFooter,
} from "../../../../Components/ui/dialog";
import { Label } from "../../../../Components/ui/label";

export default function ModalContent({
  action,
  onClose,
  selectedLoad,
  onUpdateLoad,
  drivers,
  shippers,
  onUpdateAllLoads,
}) {
  const [email, setEmail] = useState("");
  const [newStatus, setNewStatus] = useState(selectedLoad?.status || "");
  const [selectedDocument, setSelectedDocument] = useState("");
  const fileInputRef = useRef(null);
  const [selectedVehicle, setSelectedVehicle] = useState("");
  const [viewedPdf, setViewedPdf] = useState(null);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Estados para pickup
  const [pickupEta, setPickupEta] = useState(selectedLoad?.expected_pickup_date || "");
  const [pickupBusinessName, setPickupBusinessName] = useState(
    selectedLoad?.pickup_business_name || "Unknown Business"
  );
  const [pickupLocationType, setPickupLocationType] = useState(
    selectedLoad?.pickup_location_type || "Unknown Location"
  );
  const [pickupCustomerName, setPickupCustomerName] = useState(
    selectedLoad?.pickup_customer_name || "Unknown Name"
  );
  const [pickupCustomerEmail, setPickupCustomerEmail] = useState(
    selectedLoad?.pickup_customer_email || "Unknown E-mail"
  );
  const [pickupAddress, setPickupAddress] = useState(
    selectedLoad?.pickup_address || "Unknown Address"
  );
  const [pickupCity, setPickupCity] = useState(selectedLoad?.pickup_city || "Unknown City");
  const [pickupState, setPickupState] = useState(
    selectedLoad?.pickup_state || "Unknown State"
  );
  const [pickupZipCode, setPickupZipcode] = useState(
    selectedLoad?.pickup_zipcode || "Unknown ZipCode"
  );
  const [pickupCustomerPhone, setPickupCustomerPhone] = useState(
    selectedLoad?.pickup_customer_phone || "Unknown Phone"
  );

  // Estados para delivery
  const [deliveryEta, setDeliveryEta] = useState(selectedLoad?.expected_dropoff_date || "");
  const [deliveryBusinessName, setDeliveryBusinessName] = useState(
    selectedLoad?.delivery_business_name || "Unknown Business"
  );
  const [deliveryLocationType, setDeliveryLocationType] = useState(
    selectedLoad?.delivery_location_type || "Unknown Location"
  );
  const [deliveryCustomerName, setDeliveryCustomerName] = useState(
    selectedLoad?.delivery_customer_name || "Unknown Name"
  );
  const [deliveryCustomerEmail, setDeliveryCustomerEmail] = useState(
    selectedLoad?.delivery_customer_email || "Unknown E-mail"
  );
  const [deliveryAddress, setDeliveryAddress] = useState(
    selectedLoad?.delivery_address || "Unknown Address"
  );
  const [deliveryCity, setDeliveryCity] = useState(
    selectedLoad?.delivery_city || "Unknown City"
  );
  const [deliveryState, setDeliveryState] = useState(
    selectedLoad?.delivery_state || "Unknown State"
  );
  const [deliveryZipCode, setDeliveryZipcode] = useState(
    selectedLoad?.delivery_zipcode || "Unknown ZipCode"
  );
  const [deliveryCustomerPhone, setDeliveryCustomerPhone] = useState(
    selectedLoad?.delivery_customer_phone || "Unknown Phone"
  );

  // Estados para payment
  const [paymentRate, setPaymentRate] = useState(selectedLoad?.payment_rate || "");
  const [paymentType, setPaymentType] = useState(selectedLoad?.payment_type || "");
  const [paymentMethod, setPaymentMethod] = useState(selectedLoad?.payment_method || "");

  // Estados para driver e shipper
  const [selectedDriver, setSelectedDriver] = useState("");
  const [selectedShipper, setSelectedShipper] = useState("");

  useEffect(() => {
    setNewStatus(selectedLoad?.status || "");
  }, [selectedLoad]);

  const allStatusOptions = [
    { id: 1, name: "New" },
    { id: 2, name: "Assigned" },
    { id: 3, name: "Confirmed" },
    { id: 4, name: "Picked Up" },
    { id: 5, name: "Dropped Off" },
    { id: 6, name: "Delivered" },
    { id: 7, name: "Billed" },
    { id: 8, name: "Paid" },
    { id: 9, name: "Cancelled" },
    { id: 10, name: "Archived" },
  ];

  const isBeforePickedUp = ["New", "Assigned", "Confirmed"].includes(selectedLoad?.status);
  const isDroppedOrLater = [
    "Dropped Off",
    "Delivered",
    "Billed",
    "Paid",
    "Cancelled",
    "Archived",
  ].includes(selectedLoad?.status);

  const filteredStatusOptions = allStatusOptions.filter((option) => {
    if (isBeforePickedUp) {
      return ["Picked Up", "Cancelled"].includes(option.name);
    }
    return true;
  });

  if (action === "Reassign Driver") {
    return (
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reassign Driver</DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-1 gap-4 p-4">
          <div className="relative">
            <Label
              htmlFor="driver"
              className="absolute -top-[10px] text-[0.8rem] bg-[#1c1b19] px-1 left-2"
            >
              Select Driver <span className="text-rose-500">*</span>
            </Label>
            <select
              id="driver"
              value={selectedDriver}
              onChange={(e) => setSelectedDriver(e.target.value)}
              className="w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm mt-2"
            >
              <option value="">Select a driver</option>
              {drivers.map((driver) => (
                <option key={driver.id} value={driver.id} className="bg-zinc-800 text-white">
                  {driver.user?.first_name} {driver.user?.last_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <DialogFooter>
          <Button
            disabled={isLoading}
            onClick={async () => {
              if (!selectedDriver) {
                alert("Please select a driver");
                return;
              }

              setIsLoading(true);
              try {
                const formData = {
                  driver_id: selectedDriver,
                };
                const userToken = localStorage.getItem("token");
                const response = await axios.post(
                  `https://new.cajuu.app/api/loadtransport-update-view-details/${selectedLoad.id}`,
                  formData,
                  {
                    headers: {
                      Authorization: `Bearer ${userToken}`,
                      "Content-Type": "multipart/form-data",
                      "Screen-Name": "/Load",
                    },
                  }
                );
                console.log("Driver updated successfully:", response.data);

                const selectedDriverObj = drivers.find(
                  (d) => String(d.id) === String(selectedDriver)
                );
                const driverName = selectedDriverObj
                  ? `${selectedDriverObj.user?.first_name || ""} ${
                      selectedDriverObj.user?.last_name || ""
                    }`.trim()
                  : "Unknown Driver";

                const updatedLoad = {
                  ...selectedLoad,
                  driver_id: selectedDriver,
                  driver: driverName || selectedLoad.driver,
                };

                onUpdateLoad(updatedLoad);
                onUpdateAllLoads(selectedLoad.id, {
                  driver_id: selectedDriver,
                  driver: driverName || selectedLoad.driver,
                });
              } catch (error) {
                console.error("Error updating driver", error);
              } finally {
                setIsLoading(false);
                onClose();
              }
            }}
          >
            {isLoading ? "Updating..." : "Update Driver"}
          </Button>
          <Button onClick={onClose} variant="outline">
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    );
  }

  if (action === "Edit Shipper") {
    return (
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Shipper</DialogTitle>
        </DialogHeader>

        <div className="mt-4 relative">
          <Label
            htmlFor="shipper"
            className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
          >
            Select Shipper <span className="text-rose-500">*</span>
          </Label>
          <select
            id="shipper"
            value={selectedShipper}
            onChange={(e) => setSelectedShipper(e.target.value)}
            className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
          >
            <option className="bg-zinc-800 text-white" value="">
              Select a shipper
            </option>
            {shippers.map((shipper) => (
              <option className="bg-zinc-800 text-white" key={shipper.id} value={shipper.id}>
                {shipper.shipper_name}
              </option>
            ))}
          </select>
        </div>

        <div className="mt-4 relative">
          <Label
            htmlFor="address_line_1"
            className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
          >
            Address Line 1 <span className="text-rose-500">*</span>
          </Label>
          <input
            type="text"
            id="address_line_1"
            value={selectedLoad.shipper?.address_line_1 || ""}
            onChange={(e) =>
              onUpdateLoad({
                ...selectedLoad,
                shipper: {
                  ...selectedLoad.shipper,
                  address_line_1: e.target.value,
                },
              })
            }
            className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
          />
        </div>

        <div className="mt-4 relative">
          <Label
            htmlFor="address_line_2"
            className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
          >
            Address Line 2
          </Label>
          <input
            type="text"
            id="address_line_2"
            value={selectedLoad.shipper?.address_line_2 || ""}
            onChange={(e) =>
              onUpdateLoad({
                ...selectedLoad,
                shipper: {
                  ...selectedLoad.shipper,
                  address_line_2: e.target.value,
                },
              })
            }
            className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
          />
        </div>

        <DialogFooter>
          <Button
            disabled={isLoading}
            onClick={async () => {
              if (!selectedShipper) return;

              setIsLoading(true);
              try {
                const formData = {
                  shipper_id: selectedShipper,
                  address_line_1: selectedLoad.shipper?.address_line_1 || "",
                  address_line_2: selectedLoad.shipper?.address_line_2 || "",
                };
                const userToken = localStorage.getItem("token");
                const response = await axios.post(
                  `https://new.cajuu.app/api/loadtransport-update-view-details/${selectedLoad.id}`,
                  formData,
                  {
                    headers: {
                      Authorization: `Bearer ${userToken}`,
                      "Content-Type": "multipart/form-data",
                      "Screen-Name": "/Load",
                    },
                  }
                );
                console.log("Shipper updated successfully:", response.data);

                const selectedShipperObj = shippers.find(
                  (s) => String(s.id) === String(selectedShipper)
                );
                const shipperName = selectedShipperObj ? selectedShipperObj.shipper_name : "";

                const updatedLoad = {
                  ...selectedLoad,
                  shipper_id: selectedShipper,
                  shipper: {
                    ...selectedLoad.shipper,
                    shipper_name: shipperName,
                  },
                };

                onUpdateLoad(updatedLoad);
                onUpdateAllLoads(selectedLoad.id, updatedLoad);
              } catch (error) {
                console.error("Error updating shipper", error);
              } finally {
                setIsLoading(false);
                onClose();
              }
            }}
          >
            {isLoading ? "Updating..." : "Update Shipper"}
          </Button>
          <Button onClick={onClose} variant="outline">
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    );
  }

  if (action === "Provide Pickup ETA") {
    return (
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Provide Pickup ETA</DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          <div className="relative col-span-1">
            <Label
              htmlFor="pickup_business_name"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Business Name:
            </Label>
            <input
              type="text"
              id="pickup_business_name"
              value={pickupBusinessName}
              onChange={(e) => setPickupBusinessName(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="pickup_location_type"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Location Type:
            </Label>
            <input
              type="text"
              id="pickup_location_type"
              value={pickupLocationType}
              onChange={(e) => setPickupLocationType(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="pickup_customer_name"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Customer Name:
            </Label>
            <input
              type="text"
              id="pickup_customer_name"
              value={pickupCustomerName}
              onChange={(e) => setPickupCustomerName(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="pickup_customer_email"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Customer Email:
            </Label>
            <input
              type="email"
              id="pickup_customer_email"
              value={pickupCustomerEmail}
              onChange={(e) => setPickupCustomerEmail(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="pickup_customer_phone"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Phone:
            </Label>
            <input
              type="text"
              id="pickup_customer_phone"
              value={pickupCustomerPhone}
              onChange={(e) => setPickupCustomerPhone(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-2">
            <Label
              htmlFor="pickup_address"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Address:
            </Label>
            <input
              type="text"
              id="pickup_address"
              value={pickupAddress}
              onChange={(e) => setPickupAddress(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="pickup_city"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              City:
            </Label>
            <input
              type="text"
              id="pickup_city"
              value={pickupCity}
              onChange={(e) => setPickupCity(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="pickup_state"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              State:
            </Label>
            <input
              type="text"
              id="pickup_state"
              value={pickupState}
              onChange={(e) => setPickupState(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="pickup_zipcode"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Zip Code:
            </Label>
            <input
              type="text"
              id="pickup_zipcode"
              value={pickupZipCode}
              onChange={(e) => setPickupZipcode(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={async () => {
              setIsLoading(true);
              const formData = {
                pickup_business_name: pickupBusinessName,
                pickup_location_type: pickupLocationType,
                pickup_customer_name: pickupCustomerName,
                pickup_customer_email: pickupCustomerEmail,
                pickup_customer_phone: pickupCustomerPhone,
                pickup_address: pickupAddress,
                pickup_city: pickupCity,
                pickup_state: pickupState,
                pickup_zipcode: pickupZipCode,
              };

              try {
                const userToken = localStorage.getItem("token");
                await axios.post(
                  `https://new.cajuu.app/api/loadtransport-update-view-details/${selectedLoad.id}`,
                  formData,
                  {
                    headers: {
                      Authorization: `Bearer ${userToken}`,
                      "Content-Type": "multipart/form-data",
                      "Screen-Name": "/Load",
                    },
                  }
                );
                onUpdateLoad({ ...selectedLoad, ...formData });
                onClose();
              } catch (error) {
                console.error("Error updating pickup details", error);
              } finally {
                setIsLoading(false);
              }
            }}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    );
  }

  if (action === "Provide Delivery ETA") {
    return (
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Provide Delivery ETA</DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-4">
          <div className="relative col-span-1">
            <Label
              htmlFor="delivery_business_name"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Business Name:
            </Label>
            <input
              type="text"
              id="delivery_business_name"
              value={deliveryBusinessName}
              onChange={(e) => setDeliveryBusinessName(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="delivery_location_type"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Location Type:
            </Label>
            <input
              type="text"
              id="delivery_location_type"
              value={deliveryLocationType}
              onChange={(e) => setDeliveryLocationType(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="delivery_customer_name"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Customer Name:
            </Label>
            <input
              type="text"
              id="delivery_customer_name"
              value={deliveryCustomerName}
              onChange={(e) => setDeliveryCustomerName(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="delivery_customer_email"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Customer Email:
            </Label>
            <input
              type="email"
              id="delivery_customer_email"
              value={deliveryCustomerEmail}
              onChange={(e) => setDeliveryCustomerEmail(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="delivery_customer_phone"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Phone:
            </Label>
            <input
              type="text"
              id="delivery_customer_phone"
              value={deliveryCustomerPhone}
              onChange={(e) => setDeliveryCustomerPhone(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-2">
            <Label
              htmlFor="delivery_address"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Address:
            </Label>
            <input
              type="text"
              id="delivery_address"
              value={deliveryAddress}
              onChange={(e) => setDeliveryAddress(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="delivery_city"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              City:
            </Label>
            <input
              type="text"
              id="delivery_city"
              value={deliveryCity}
              onChange={(e) => setDeliveryCity(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="delivery_state"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              State:
            </Label>
            <input
              type="text"
              id="delivery_state"
              value={deliveryState}
              onChange={(e) => setDeliveryState(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="delivery_zipcode"
              className="absolute -top-[3px] text-[0.8rem] bg-[#1c1b19] px-1 left-1"
            >
              Zip Code:
            </Label>
            <input
              type="text"
              id="delivery_zipcode"
              value={deliveryZipCode}
              onChange={(e) => setDeliveryZipcode(e.target.value)}
              className="mt-2 w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancel
          </Button>
          <Button
            onClick={async () => {
              setIsLoading(true);
              const formData = {
                delivery_business_name: deliveryBusinessName,
                delivery_location_type: deliveryLocationType,
                delivery_customer_name: deliveryCustomerName,
                delivery_customer_email: deliveryCustomerEmail,
                delivery_customer_phone: deliveryCustomerPhone,
                delivery_address: deliveryAddress,
                delivery_city: deliveryCity,
                delivery_state: deliveryState,
                delivery_zipcode: deliveryZipCode,
              };

              try {
                const userToken = localStorage.getItem("token");
                await axios.post(
                  `https://new.cajuu.app/api/loadtransport-update-view-details/${selectedLoad.id}`,
                  formData,
                  {
                    headers: {
                      Authorization: `Bearer ${userToken}`,
                      "Content-Type": "multipart/form-data",
                      "Screen-Name": "/Load",
                    },
                  }
                );
                onUpdateLoad({ ...selectedLoad, ...formData });
                onClose();
              } catch (error) {
                console.error("Error updating pickup details", error);
              } finally {
                setIsLoading(false);
              }
            }}
            disabled={isLoading}
          >
            {isLoading ? "Saving..." : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    );
  }

  if (action === "Edit Payment") {
    return (
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Edit Payment</DialogTitle>
        </DialogHeader>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
          <div className="relative col-span-1">
            <Label
              htmlFor="payment_rate"
              className="absolute -top-[10px] text-[0.8rem] bg-[#1c1b19] px-1 left-2"
            >
              Payment Rate <span className="text-rose-500">*</span>
            </Label>
            <input
              type="text"
              id="payment_rate"
              value={paymentRate}
              onChange={(e) => setPaymentRate(e.target.value)}
              className="w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm mt-2"
              placeholder="Enter payment rate"
            />
          </div>

          <div className="relative col-span-1">
            <Label
              htmlFor="payment_type"
              className="absolute -top-[10px] text-[0.8rem] bg-[#1c1b19] px-1 left-2"
            >
              Payment Type <span className="text-rose-500">*</span>
            </Label>
            <select
              id="payment_type"
              value={paymentType}
              onChange={(e) => setPaymentType(e.target.value)}
              className="w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm mt-2"
            >
              <option value="">Select a payment type</option>
              {["COD", "COP", "2 BD", "5 BD", "7 BD", "15 BD", "30 BD"].map((type) => (
                <option key={type} value={type} className="bg-zinc-800 text-white">
                  {type}
                </option>
              ))}
            </select>
          </div>

          <div className="relative col-span-2">
            <Label
              htmlFor="payment_method"
              className="absolute -top-[10px] text-[0.8rem] bg-[#1c1b19] px-1 left-2"
            >
              Payment Method <span className="text-rose-500">*</span>
            </Label>
            <select
              id="payment_method"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
              className="w-full py-2 px-3 border border-white text-white bg-transparent rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary sm:text-sm mt-2"
            >
              <option value="">Select a payment method</option>
              {[
                "ACH",
                "Check",
                "Zelle",
                "Venmo",
                "Cashapp",
                "Uship",
                "Cash",
                "PayPal",
                "Credit card",
                "Debit",
                "Comcheck",
                "Echeck",
                "Electronic Check",
              ].map((method) => (
                <option key={method} value={method} className="bg-zinc-800 text-white">
                  {method}
                </option>
              ))}
            </select>
          </div>
        </div>

        <DialogFooter>
          <Button
            onClick={async () => {
              if (!paymentRate || !paymentType || !paymentMethod) {
                alert("Please fill in all fields");
                return;
              }
              setIsLoading(true);
              try {
                const formData = {
                  payment_rate: paymentRate,
                  payment_type: paymentType,
                  payment_method: paymentMethod,
                };
                const userToken = localStorage.getItem("token");
                await axios.post(
                  `https://new.cajuu.app/api/loadtransport-update-view-details/${selectedLoad.id}`,
                  formData,
                  {
                    headers: {
                      Authorization: `Bearer ${userToken}`,
                      "Content-Type": "multipart/form-data",
                      "Screen-Name": "/Load",
                    },
                  }
                );

                const updatedLoad = {
                  ...selectedLoad,
                  ...formData,
                };
                onUpdateLoad(updatedLoad);
              } catch (error) {
                console.error("Error updating payment", error);
              } finally {
                setIsLoading(false);
                onClose();
              }
            }}
          >
            {isLoading ? "Saving..." : "Update Payment"}
          </Button>
          <Button onClick={onClose} variant="outline">
            Cancel
          </Button>
        </DialogFooter>
      </DialogContent>
    );
  }

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{action}</DialogTitle>
        <DialogDescription>
          This is a placeholder for the {action.toLowerCase()} functionality.
        </DialogDescription>
      </DialogHeader>
      <div className="mt-4">
        <p>Implement {action.toLowerCase()} logic here.</p>
      </div>
      <Button onClick={onClose} className="mt-4">
        Close
      </Button>
    </DialogContent>
  );
}